import Row from './component';
import enhance from './container';

export default enhance(Row);
